/*
 * Name: Scaffolding-WP
 * Author: Craig Cooper
 * Author URI: http://craigomatic.co.uk
 * Description: A bare bones front-end framework for Wordpress
 * Version: 0.1
 */


toggleNav();
toggleSearch();
scrollAction();

const body = document.body; 
const navActive = "nav-active";
const searchActive = "search-active";

function closeSearch() {
	body.classList.remove(searchActive);
}

function closeNav() {
	body.classList.remove(navActive);
}

function toggleNav() {
	const $navTrigger = document.getElementById("navTrigger");

	$navTrigger.addEventListener("click", () => {
		if (body.classList.contains(navActive)) {
			closeNav();
		} else {
			closeSearch();
			body.classList.add(navActive);
		}
	});
}

function toggleSearch() {
	const $toggleSearch = document.getElementById("searchTrigger");
	const $closeSearch = document.getElementById("searchClose");

	$toggleSearch.addEventListener("click", () => {
		if (body.classList.contains(searchActive)) {
			closeSearch();
		} else {
			closeNav();
			body.classList.add(searchActive);
		}
	});

	$closeSearch.addEventListener("click", () => {
		closeSearch();
	});
}

function scrollAction() {
	if (window.innerWidth < 1024) {

		let $current = scrollY;
		const $pageHeader = document.getElementById("pageHeader");
		const scrolled = "page-header--scrolled";

		window.addEventListener("scroll", () => {
			if (scrollY > $current + 20) {
				$pageHeader.classList.add(scrolled);
			} else if (scrollY < $current) {
				$pageHeader.classList.remove(scrolled);
			}
			setTimeout(() => {
				$current = scrollY;
			}, 1000);
		});
	}
}

// function selectBorders() {
// 	const hiddenSelect = Array.from(document.querySelectorAll(".thwvs-select"));
// 	hiddenSelect.forEach((arrayElement, index) => {
// 		if (window.getComputedStyle(hiddenSelect[index]).display === "none") {
// 			hiddenSelect[index].parentElement.parentElement.classList.remove("variation__options--select");
// 		}
// 	});
// }